import React, { useState } from "react";
import ActionButtons from '../Controls/ActionButtons';
import { getData } from '../../json-api/JsonApiUtils';
import { Collapse } from 'react-bootstrap';
import PropTypes from "prop-types";
import i18n from '../../../src/i18n/translate';

const CollapsibleTableCell = props => {
  const { expandedData, buildDisplay, displayName, row, toolTip, dataUrl, dataFilters, sortBy, authToken } = props;
  const [viewToggled, setViewToggled] = useState(false);
  const [localData, setLocalData] = useState();

  const onToggleClicked = () => {
    const setToggle = !viewToggled;
    if(setToggle && !localData) {
      getAsyncData();
    }
    setViewToggled(setToggle);
  }

  const createButton = () => {
    return [{
      icon: viewToggled ? 'minus' : 'plus',
      title: viewToggled ? i18n.t('Hide') : i18n.t('View'),
      tooltip: toolTip || '',
      type: 'content',
      actionType: 'callToAction',
      action: onToggleClicked
    }];
  }

  const actionsFormatter = () => {
    if (!row) return null;
    return (<ActionButtons row={row} buttons={createButton()} />);
  }

  const getAsyncData = async () => {
    if(expandedData && !localData) {
      setLocalData(expandedData);
    } else if(!expandedData && !localData && dataUrl) {
      const { data } = await getData(dataUrl, {
        authToken,
        filters: dataFilters,
        sorts: sortBy && [{ value: sortBy, direction: 'asc' }],
        page: { number: 1, size: 20 }
      });
      setLocalData(data);
    }
  }

  const dataFormatter = () => {
    if(!localData || localData.length === 0) return (<div>{i18n.t('No data')}</div>);
    if(buildDisplay) return buildDisplay(localData);
    return localData.map((data, i) => {
      return (<div key={i}>{data[displayName]}</div>);
    });
  }

  return (<>
    <Collapse in={viewToggled}>
      <div className="m-b-10">{viewToggled && dataFormatter()}</div>
    </Collapse>
    {actionsFormatter()}
  </>);
};

CollapsibleTableCell.propTypes = {
  authToken: PropTypes.string,
  dataFilters: PropTypes.object,
  dataUrl: PropTypes.string,
  displayName: PropTypes.string,
  expandedData: PropTypes.array,
  buildDisplay: PropTypes.func,
  row: PropTypes.object,
  sortBy: PropTypes.object,
  toolTip: PropTypes.string
};

export default CollapsibleTableCell;
